import React from 'react';
import more from "../../img/carouselMoreArrow.svg";

const servicesData = [
    {
        title: "DexPay — Виртуальные карты",
        content: (
            <div className="accordion-product-body">
                <p>
                    DexPay — это многофункциональный виртуальный кошелёк и дебетовая карта, позволяющие удобно
                    хранить активы, быстро выпускать карты и безопасно расплачиваться по всему миру, как онлайн,
                    так и в офлайн‑магазинах.
                </p>

                <p className="section-heading">Основные преимущества сервиса:</p>
                <ul className="service-list">
                    <li><strong>Быстрый выпуск карты</strong> — виртуальная карта выпускается менее чем за 10 минут прямо через веб‑приложение, без сложной проверки и бумажной волокиты.</li>
                    <li><strong>Минимальные требования</strong> — для оформления достаточно действующего телефона и e‑mail, без классического банковского онбординга.</li>
                    <li><strong>Гибкое пополнение</strong> — карта пополняется напрямую из кошелька DexPay, после чего средства сразу доступны для оплаты.</li>
                    <li><strong>Глобальное использование</strong> — оплата по всему миру в интернет‑магазинах и физических точках, поддержка популярных онлайн‑сервисов, маркетплейсов, IT‑платформ и подписок.</li>
                    <li><strong>Высокие лимиты и безопасность</strong> — лимит расходов до 100&nbsp;000&nbsp;$ в день и поддержка 3D Secure, что обеспечивает дополнительную защиту операций.</li>
                    <li><strong>Интеграция с Apple Pay и Google Pay</strong> — возможность добавления карты в Apple Pay / Google Pay для бесконтактной оплаты в магазинах, приложениях и онлайн.</li>
                    <li><strong>Поддержка 24/7 и многоязычность</strong> — служба поддержки доступна круглосуточно, отвечает быстро и работает на нескольких языках, что упрощает использование сервиса в разных странах.</li>
                </ul>

                <p className="section-heading">Реферальная программа:</p>
                <p>
                    У DexPay есть продуманная партнёрская (реферальная) программа, которая позволяет превратить
                    использование сервиса в источник пассивного дохода. Регистрация в веб‑приложении занимает
                    считанные минуты. Пользователь получает уникальную реферальную ссылку и делится ею с аудиторией,
                    клиентами или друзьями. Владелец ссылки получает комиссию с покупок карт и транзакций
                    привлечённых пользователей, формируя стабильный поток вознаграждений.
                </p>

                <p className="section-heading">Как это выглядит для клиента:</p>
                <p>
                    Пользователь регистрируется в веб‑приложении DexPay, выпускает виртуальную карту, пополняет
                    её из кошелька и сразу может платить в онлайн‑сервисах, магазинах и приложениях, в том числе
                    через Apple Pay / Google Pay. При желании он подключает реферальную программу и начинает
                    получать регулярные выплаты за активность привлечённых клиентов.
                </p>

                <a
                    className="accordion-more-btn"
                    href="https://dexpay.cards"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Перейти на сайт
                    <img src={more} alt=""/>
                </a>
            </div>
        ),
    },
    {
        title: "DEXPAY — цифровые активы",
        content: (
            <div className="accordion-product-body">
                <p>
                    DEXPAY — это онлайн‑сервис покупки цифровых активов, эквивалентных USDT, за рубли с помощью
                    банковских карт и эквайринга, без участия третьих лиц. Платформа позволяет быстро пополнить
                    баланс виртуальными активами по прозрачному курсу, привязанному к актуальному курсу валют и
                    ЦБ РФ. Основной акцент сделан на безопасности платежей, удобном интерфейсе и понятной логике
                    покупки даже для новичков.
                </p>
                <p>
                    Сервис ориентирован как на частных пользователей, так и на бизнес, включая компании, работающие
                    с маркетплейсами и трансграничными расчётами. На сайте есть отдельные разделы «Бизнесу» и
                    «Партнёрам», а также интеграция с логистическими решениями («доставка в белую» и
                    карго‑доставка «под ключ» с полным пакетом документов при необходимости).
                </p>
                <p>
                    DEXPAY подчёркивает свою правовую и налоговую актуальность, опираясь на изменения российского
                    законодательства в сфере цифровых финансовых активов и цифровой валюты
                    (законы 259‑ФЗ, 115‑ФЗ, 324‑ФЗ и др.), а также на согласование использования
                    криптовалюты в трансграничных расчётах ЦБ РФ и Минфином.
                </p>

                <p className="section-heading">Описание:</p>
                <p>
                    DEXPAY — это современный сервис для быстрой и безопасной покупки цифровых активов,
                    полностью эквивалентных USDT, за рубли с банковской карты. Платформа работает через
                    официальный банковский эквайринг, поэтому ваши платежные данные остаются защищёнными,
                    а все операции проходят без участия сторонних посредников.
                </p>
                <p>
                    Благодаря простому и интуитивному интерфейсу пополнить баланс виртуальными активами можно
                    за несколько минут — сервис подойдёт даже тем, кто только делает первые шаги в мире цифровых
                    валют. Актуальный курс привязан к рыночным значениям и курсу ЦБ РФ, что обеспечивает
                    прозрачность и предсказуемость каждой операции.
                </p>
                <p>
                    DEXPAY подходит как частным пользователям, так и компаниям, которым нужны удобные решения
                    для расчётов и работы с маркетплейсами. Для бизнеса доступны расширенные возможности:
                    консультации по учёту цифровых активов, сопровождение операций и интеграция с
                    логистическими сервисами, включая как полностью «белую» поставку с полным пакетом
                    документов, так и карго‑доставку с минимальной бюрократией и быстрыми сроками.
                </p>
                <p>
                    Сервис опирается на действующее российское законодательство в сфере цифровых финансовых
                    активов, предлагая клиентам инструмент, который сочетает технологичность, безопасность
                    и реальную юридическую основу.
                </p>

                <a
                    className="accordion-more-btn"
                    href="https://dexpay.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Перейти на сайт
                    <img src={more} alt=""/>
                </a>
            </div>
        ),
    },
    {
        title: "Visa Smart — Оформление виз",
        content: (
            <div className="accordion-product-body">
                <p>
                    Visa Smart — это современный сервис дистанционного оформления виз для жителей всей России,
                    который сочетает умные алгоритмы и живую экспертизу визовых консультантов. Компания помогает
                    получить шенгенские визы (Франция, Италия, Испания и другие страны Шенгенской зоны), а также
                    визы в США, Великобританию и Японию — от стандартных туристических до деловых, студенческих
                    и сложных случаев с предыдущими отказами.
                </p>
                <p>
                    Главная особенность сервиса — <strong>честный аудит шансов до оплаты</strong>: специалисты
                    заранее изучают паспортную историю, прошлые отказы и финансовый профиль, предупреждают о
                    рисках и не берут заказ, если вероятность отказа критически низкая.
                </p>
                <p>
                    Все взаимодействие проходит онлайн: консультации, подготовка документов, проверка справок,
                    бронирования отелей и транспорта, оформление страховки и составление маршрутного листа для
                    консула проводятся полностью дистанционно. Клиент лично посещает только визовый центр для
                    сдачи биометрии (если она ещё не сдавалась). Для записи на подачу Visa Smart использует
                    собственный бот, который 24/7 мониторит появление свободных слотов.
                </p>

                <p className="section-heading">Результаты за 2024–2025 годы:</p>
                <ul className="service-list">
                    <li>До <strong>97%</strong> одобренных заявок по шенгенским визам.</li>
                    <li><strong>93–95%</strong> по направлениям США, Великобритания и Япония, включая сложные случаи и апелляции.</li>
                </ul>

                <p className="section-heading">Структура услуг:</p>
                <ul className="service-list">
                    <li><strong>Подготовка документов</strong> — по фиксированной цене (анкеты, бронирования, страховка, маршруты, проверка справок).</li>
                    <li><strong>Запись на подачу</strong> — стандартная или ускоренная через бота, цена зависит от страны, города и способа записи.</li>
                    <li><strong>Консульские и сервисные сборы</strong> — оплачиваются клиентом напрямую при подаче.</li>
                </ul>

                <p className="section-heading">Visa Smart подойдёт тем, кто хочет:</p>
                <ul className="service-list">
                    <li>Оформить визу без визита в офис и без лишней бюрократии.</li>
                    <li>Повысить шансы на одобрение за счёт профессиональной стратегии и анализа рисков.</li>
                    <li>Быстро записаться на подачу через автоматизированный бот, особенно при дефиците слотов.</li>
                    <li>Получить детальное сопровождение от первого вопроса до получения паспорта с визой.</li>
                </ul>

                <a
                    className="accordion-more-btn"
                    href="https://visasmart.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Перейти на сайт
                    <img src={more} alt=""/>
                </a>
            </div>
        ),
    },
    {
        title: "TG‑ассистент — Умная запись через Telegram",
        content: (
            <div className="accordion-product-body">
                <p>
                    TG‑ассистент превращает ваш Telegram и Max в полноценную систему онлайн‑записи и личного
                    секретаря, который работает за вас 24/7. Клиенты записываются в привычном мессенджере, а вы
                    зарабатываете и управляете расписанием через удобную бот‑админку — без таблиц, ручной
                    переписки и сложных программ.
                </p>
                <p>
                    Сервис создан для психологов, репетиторов, личных тренеров, коучей, консультантов и всех,
                    кто проводит личные онлайн или офлайн встречи. Вместо хаотичных чатов и забытых
                    договорённостей у вас появляется единая точка управления всеми записями.
                </p>

                <p className="section-heading">Внутри TG‑ассистента сразу настроены:</p>
                <ul className="service-list">
                    <li><strong>Два клиента‑бота</strong> — отдельный бот для клиентов в Telegram и такой же бот в Max, чтобы каждый мог записаться там, где ему удобно.</li>
                    <li><strong>Бот‑админка в Telegram</strong> — настройка расписания, форматов и длительности встреч, стоимости, типов услуг и актуальных слотов.</li>
                    <li><strong>Автоматическое или ручное подтверждение</strong> записей, чтобы вы контролировали загрузку.</li>
                    <li><strong>Гибкая работа со слотами</strong> — блокировка, перенос, открытие новых окон в пару кликов.</li>
                </ul>

                <p className="section-heading">Оплата и тарифы:</p>
                <p>
                    Оплаты за консультации подключаются через ЮKassa и другие платёжные решения: разовые
                    платежи, предоплаты и абонементы — деньги сразу поступают на ваши реквизиты.
                    TG‑ассистент работает по подписочной модели в рублях для специалистов из России,
                    без скрытых комиссий за каждую запись.
                </p>

                <p className="section-heading">Сервис решает три главные проблемы экспертов:</p>
                <ul className="service-list">
                    <li>Убирает рутинную переписку по расписанию — клиент сам выбирает формат и время.</li>
                    <li>Снижает количество срывов и путаницы с датами за счёт чётких слотов и подтверждений.</li>
                    <li>Позволяет сконцентрироваться на работе с людьми, а не на администрировании.</li>
                </ul>

                <p>
                    Подключение занимает <strong>до 1 рабочего дня</strong>: мы создаём и персонализируем ваших
                    ботов, настраиваем расписание и помогаем запустить первые записи. Уже на следующий день
                    ваши клиенты смогут записываться сами — прямо из мессенджера, в пару нажатий.
                </p>

                <a
                    className="accordion-more-btn"
                    href="https://tgassistant.ru"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Перейти на сайт
                    <img src={more} alt=""/>
                </a>
            </div>
        ),
    },
];

export default servicesData;